export const TOKEN_SQUARE_MOVEMENT_DURATION = 500;
export const DC_TO_AC_MOVEMENT_DURATION = 3000;
